import { useBlockProps } from "@wordpress/block-editor";
const Save = (props) => {
	return <div>{props.attributes.formId}</div>;
};

export default Save;
